import { Dropdown, DropdownList, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { CalendarIcon } from 'cokitchen-icons';
import SingleBottomNav from 'components/base/single-bottom-nav';

import useNewCareerPositionContext from 'contexts/career-position.context';
import moment from 'moment';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';

type Props = {
  onEditComplete: () => void;
};
const EditApplicationSettings = ({ onEditComplete }: Props) => {
  const { createJobPositionForm, setCreateJobPositionForm } = useNewCareerPositionContext();
  const [openCalendar, setOpenCalendar] = useState(true);

  const [loading, setLoading] = useState(false);

  const { job_id } = useParams();

  const handleUpdateJobPosting = async () => {
    setLoading(true);

    try {
      await apiService.put(`careers/jobs/${job_id}`, {
        data: {
          application_deadline: createJobPositionForm.applicationDeadline,
          no_of_openings: Number(createJobPositionForm.noOfOpenings),
          status: createJobPositionForm.status
        }
      });

      toast(<ToastMessage type='success' message={`Job updated successfully`} />);
      onEditComplete();
    } catch {
      toast(<ToastMessage type='error' message={`There was a problem creating position `} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='space-y-4'>
      <div>
        <p className='font-medium text-base mb-2'>Application deadline</p>
        <Dropdown
          onClickOutside={() => setOpenCalendar(false)}
          content={
            <div
              onClick={() => setOpenCalendar(true)}
              className='flex justify-between items-center cursor-pointer border border-gray-1 rounded-md p-3 text-gray-6/40 font-medium bg-transparent'>
              <span
                className={`${
                  createJobPositionForm.applicationDeadline ? 'text-gray-6' : 'text-gray-6/40'
                }`}>
                {createJobPositionForm.applicationDeadline
                  ? moment(new Date(createJobPositionForm.applicationDeadline)).format(
                      'ddd MMM DD, yyyy'
                    )
                  : 'Select date'}
              </span>
              <CalendarIcon className='text-gray-6/40' />
            </div>
          }>
          <DropdownList className='!max-h-max bg-transparent p-0'>
            {openCalendar && (
              <DatePicker
                selected={
                  createJobPositionForm.applicationDeadline
                    ? new Date(createJobPositionForm.applicationDeadline)
                    : undefined
                }
                open
                inline
                minDate={new Date()}
                onChange={(date) => {
                  setCreateJobPositionForm({
                    ...createJobPositionForm,
                    applicationDeadline: moment(date).format('YYYY-MM-DDTHH:mm:ssZ')
                  });
                  setOpenCalendar(false);
                }}
              />
            )}
          </DropdownList>
        </Dropdown>
      </div>
      <Input
        type='number'
        min='1'
        step='1'
        label='Number of openings'
        placeholder='Enter number of openings'
        className='w-full mt-4'
        inputClass='px-4 py-3'
        value={createJobPositionForm?.noOfOpenings || ''}
        onChange={(e) => {
          const numericValue = e.target.value.replace(/[^0-9]/g, '');
          setCreateJobPositionForm({
            ...createJobPositionForm,
            noOfOpenings: numericValue
          });
        }}
      />

      <SingleBottomNav
        loading={loading}
        onConfirm={handleUpdateJobPosting}
        backBtndisabled
        btnDisabled={loading}
      />
    </div>
  );
};

export default EditApplicationSettings;
